

import classnames from "classnames";
import {useConfig} from "../helpers/useConfig";
import { useTranslation } from 'react-i18next';

function Utils(){
 const {configData, setConfig} = useConfig();
 const { t } = useTranslation();      
}


export async function loader({ params }) {
    const json = await getMainData();
    return { json };
  }

  export async function getCssClasses() {
    const json = await getMainData();
    const current = json.jws.current;;
    const states = json.jws.states;
       
    const cssClasses = classnames ({
    snow: (states.issnowing  === 'true'),
    rain: (states.israining  === 'true'),
    night: (current.issun  === 'false'),
    dust: (current.isdusty === 'true'),
    windy: (current.iswindy === 'true'),
    sunset: (current.issunset === 'true'),
    sunrise: (current.issunrise === 'true')
  
  });
  return cssClasses;
  }


export async function getMainData() {
    const fetchJson = async () => {
        var opts = {
            headers: {
             
            }
          }
        const response = await fetch("https://v2013.02ws.co.il/02wsjson.txt", opts);
        const json = await response.json();
        return json;
        
      };
      let result = fetchJson();
     return result;
  }

export async function getBackupData() {
    const fetchJson = async () => {
        var opts = {
            headers: {
             
            }
          }
        const response = await fetch("https://www.02ws.co.il/02wsjson.txt", opts);
        const json = await response.json();
        return json;
        
      };
      let result = fetchJson();
     return result;
  }

  
export async function getActivitiesData() {
  const fetchJson = async () => {
      var opts = {
          headers: {
           
          }
        }
      const response = await fetch("https://v2013.02ws.co.il/activities.json", opts);
      const json = await response.json();
      return json;
      
    };
    let result = fetchJson();
   return result;
}
export async function getParamsData() {
  const fetchJson = async () => {
      var opts = {
          headers: {
           
          }
        }
      const response = await fetch("https://v2013.02ws.co.il/parameters.json", opts);
      const json = await response.json();
      return json;
      
    };
    let result = fetchJson();
   return result;
}
export async function getStories() {
  const fetchJson = async () => {
      var opts = {
          headers: {
           
          }
        }
      const response = await fetch("https://v2013.02ws.co.il/stories.json", opts);
      const json = await response.json();
      return json;
      
    };
    let result = fetchJson();
   return result;
}
export async function getLatestMaxMinTemp() {
  const fetchJson = async () => {
      var opts = {
          headers: {
           
          }
        }
      const response = await fetch("https://v2013.02ws.co.il/getLatestMaxMinTemp.php", opts);
      const json = await response.json();
      return json;
      
    };
    let result = fetchJson();
   return result;
}
export async function getLatestDailyRain() {
  const fetchJson = async () => {
      var opts = {
          headers: {
           
          }
        }
      const response = await fetch("https://v2013.02ws.co.il/getLatestDailyRain.php", opts);
      const json = await response.json();
      return json;
      
    };
    let result = fetchJson();
   return result;
}
export async function GetLatestYearsRainForToday() {
  const fetchJson = async () => {
      var opts = {
          headers: {
           
          }
        }
      const response = await fetch("https://v2013.02ws.co.il/GetLatestYearsRainForToday.php", opts);
      const json = await response.json();
      return json;
      
    };
    let result = fetchJson();
   return result;
}
export async function updateLikesCall(idx, command) {
  const fetchJson = async () => {
    var opts = {
       
        
      }
    const response = await fetch("https://v2013.02ws.co.il/forecastlikes_service.php?idx=" + idx + "&command=" + command , opts);
    const json = await response.json();
    return json;
    
  };
  let result = fetchJson();
  return result;

}

export async function voteLike(cm_value, gender) {
  const fetchJson = async () => {
      var opts = {
         //mode: 'no-cors',
          headers: {
           
          }
        }
      const response = await fetch("https://v2013.02ws.co.il/survey.php?SendSurveyButton=1&json_res=1&survey="+cm_value + "&survey_id=2&gender=" + gender , opts);
      const json = await response.json();
      return json;
      
    };
    let result = fetchJson();
   return result;
}

export async function getArchiveData(limit, params, lang) {
  const fetchJson = async () => {
      var opts = {
         //mode: 'no-cors',
          headers: {
           
          }
        }
      const response = await fetch("https://v2013.02ws.co.il/images/profile1/ArchiveJson.php?limit=" + limit + "&params=" + params + "&lang=" + lang , opts);
      const json = await response.json();
      return json;
      
    };
    let result = fetchJson();
   return result;
}

export async function getLatestArchiveData(limit, params, lang) {
  const fetchJson = async () => {
      var opts = {
         //mode: 'no-cors',
          headers: {
           
          }
        }
      const response = await fetch("https://v2013.02ws.co.il/images/profile1/LatestArchiveJson.php?limit=" + limit + "&params=" + params + "&lang=" + lang , opts);
      const json = await response.json();
      return json;
      
    };
    let result = fetchJson();
   return result;
}

export async function getWindData(speed, lang) {
    const fetchJson = async () => {
        var opts = {
            headers: {
             
            }
          }
        const response = await fetch("https://v2013.02ws.co.il/getWindInfo.php?speed=" + speed + "&lang=" + lang, opts);
        const json = await response.json();
        return json;
        
      };
      let result = fetchJson();
      
     return result;
  }

  export async function getForumDumb() {
    const fetchJson = async () => {
        var opts = {
            headers: {
             
            }
          }
        const response = await fetch("https://v2013.02ws.co.il/forumdump.json", opts);
        const json = await response.json();
        return json;
        
      };
      let result = fetchJson();
      
     return result;
  }

  export async function getUser(lang, email) {
    if (email == null)
      email = '';
    const fetchJson = async () => {
        var opts = {
            headers: {
             
            }
          }
        const response = await fetch("https://v2013.02ws.co.il/checkauth.php?action=getuser&lang=" + lang + "&email=" + email, opts);
        console.log('getUser=', response);
        const json = response.json();
        return json;
        
      };
      let result = fetchJson();
      
     return result;
  }

  export async function getUserByRememberMe(lang, rememberme) {
    
    const fetchJson = async () => {
        var opts = {
            headers: {
             
            }
          }
        const response = await fetch("https://v2013.02ws.co.il/checkauth.php?action=getuser&lang=" + lang + "&rememberme=" + rememberme, opts);
        console.log('getUserByRememberMe=', response);
        const json = response.json();
        return json;
        
      };
      let result = fetchJson();
      
     return result;
  }

  export async function registerGoogleUser(lang) {
    const storedUser = localStorage.getItem("currentUser");
    const postData = {
      username: storedUser.family_name,
      password: Math.floor(100000 + Math.random() * 900000),
      user_display_name:  storedUser.given_name + storedUser.family_name,
      user_nice_name: storedUser.given_name,
      priority: 0
    };
    const fetchJson = async () => {
        var opts = {
            headers: {
             'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(postData)
          }
        const response = await fetch("https://v2013.02ws.co.il/checkauth.php?action=register_with_google&lang="+lang
                                                    +"&username=" + storedUser.family_name
                                                    +"&email=" + storedUser.email 
                                                    +"&password=" + Math.floor(100000 + Math.random() * 900000)
                                                    +"&user_display_name=" + storedUser.given_name + storedUser.family_name 
                                                    +"&user_nice_name=" + storedUser.given_name + "&priority=0"
               , opts);
        const json = await response.json();
        return json;
        
      };
      let result = fetchJson();
      
     return result;
  }
  export function convertTempNextDays (json, tempunit) {

  }

  export function convertTempNextHours (json, tempunit) {

  }

  export function convertTempCurrent (json, tempunit) {

  }

  export function convertTempToday (json, tempunit) {

  }

  export function convertTempThisMonth (json, tempunit) {

  }

  export function convertTempYest (json, tempunit) {

  }


  export  function c_or_f(temp, tempunit) {
      //console.log('c_or_f tempUnit:', tempunit);
      if (tempunit == 'F') {
          return ( Math.round(((9 * temp) / 5) + 32));
      }
    
      return temp;
  }

  export function getIconDesc(icon) {
      if (icon.indexOf("cloud_1") > 0)
        return "LOW_CLOUDS";  
      if (icon.indexOf("cloud_2") > 0)
        return "LOW_CLOUDS";
      if (icon.indexOf("cloud_3") > 0)
        return "LOW_CLOUDS";
      if (icon.indexOf("partlycloudy") > 0)
        return "MEDIUM_HIGH_CLOUDS";
      if (icon.indexOf("mostlycloudy") > 0)
        return "MEDIUM_HIGH_CLOUDS";
      if (icon.indexOf("tsun") > 0)
        return "HIGH_CLOUDS";
      if (icon.indexOf("cloud_5") > 0)
        return "MEDIUM_HIGH_CLOUDS";
      if (icon.indexOf("cloudy2") > 0)
        return "CLOUDY";
      if (icon.indexOf("cloudy3") > 0)
        return "CLOUDY";
      if (icon.indexOf("dust") > 0)
        return "DUST";
      if (icon.indexOf("fog") > 0)
        return "FOG";
      if (icon.indexOf("rain_mcloudy") > 0)
        return "LIGHT_RAIN";
      if (icon.indexOf("rain2") > 0)
        return "FEW_SHOWERS";
      if (icon.indexOf("lightrain") > 0)
        return "SINGLE_SHOWER";
      if (icon.indexOf("sun_rain") > 0)
        return "SHOWERS";
      if (icon.indexOf("lightshowers") > 0)
        return "HERE_AND_THERE_RAIN";
      if (icon.indexOf("tsra") > 0)
        return "THUNDERSTORM_RAIN";
      if (icon.indexOf("ts") > 0)
        return "THUNDERSTORM";
      if (icon.indexOf("hail") > 0)
        return "HAIL";
       if (icon.indexOf("snowrain") > 0)
        return "SNOWRAIN";
        if (icon.indexOf("snow") > 0)
        return "SNOW";

      
      return "";
  }
export default Utils;
